<template>
  <div class="theme">
    <div class="pao pao2 wow slideInLeftSelf"></div>
    <myMenu :type="2" @zoomChange="initWow"></myMenu>
    <div class="theme_content">
      <div class="linear_word">THEME ACTIVITY</div>
      <div class="linear_word2 slideInUp_p">
        <div class="wow slideInUp">主题活动</div>
      </div>
      <div class="theme_list wow slideInUp" data-wow-delay="0.6s">
        <div @click="newsDec(item)" class="theme_item " v-for="(item,index) in dataList" :key="index">
          <div class="theme_item_img">
            <img :src="
              item.news_smallpic
                ? item.news_smallpic
                : require('@/assets/active_bg.png')
            " alt="推荐新闻图" />
          </div>
          <div class="theme_item_left">
            <p class="item_name">{{item.news_title}}</p>
            <p class="item_time">{{item.news_time}}</p>
            <p class="item_dec">{{item.news_demo}}</p>
          </div>
        </div>
      </div>
    </div>
    <myBottom></myBottom>
  </div>
</template>

<script>
import myMenu from '@/components/myMenu.vue'
import myBottom from '@/components/myBottom.vue'

import "wowjs/css/libs/animate.css";
import "@/assets/css/wowExtra.css";
import { WOW } from 'wowjs'
export default {
  components: { myMenu, myBottom, },
  data() {
    return {
      dataList: [],
    }
  },
  created() {
    P_getNewsList({
      park_id: this.$ParkId,
      news_type: 4,
      pageIndex: 1,
      pageSize: 10
    }).then((res) => {
      if (res.success) {
        res.data.map(item => {
          item.news_time = this.$time(item.news_time)
        })
        this.dataList = res.data
      }
    })
  },
  mounted() {
  },
  methods: {
    initWow(zoom) {
      var top = $('.theme_list').offset().top;
      var offset = zoom >= 1 ? 200 * zoom : (200 * zoom - (top - top * zoom));
      var wow = new WOW(
        {
          animateClass: 'animated',
          offset,
          callback: box => {
            $(box).removeClass('wow');
          }
        }
      );
      wow.init();
    },
    newsDec(item) {
      this.$toPage(item.news_redirect || '/themeDetail', { id: item.news_id })
    },
  },
}
</script>

<style lang="scss" scoped>
.theme {
  .pao1 {
    left: 620px;
    top: 700px;
  }
  .theme_content {
    width: 1320px;
    margin: 150px auto 180px;
    position: relative;
    z-index: 1;
    .theme_list {
      margin-top: 74px;
    }
    .theme_item {
      height: 255px;
      background: rgba(255, 255, 255, 0.8);
      box-shadow: 0px 3px 32px 0px rgba(232, 160, 46, 0.2);
      border-radius: 20px;
      display: flex;
      align-items: center;
      padding: 28px 56px;
      cursor: pointer;
      margin-bottom: 50px;
      .theme_item_img {
        width: 316px;
        height: 210px;
        background: #ddd;
        border-radius: 26px;
        position: relative;
        flex-shrink: 0;
        overflow: hidden;
        img {
          object-fit: cover;
          width: 100%;
          height: 100%;
        }
      }
      .theme_item_left {
        height: 223px;
        margin-left: 83px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-right: 79px;
        .item_name {
          font-size: 27px;
          font-weight: 500;
          text-align: r;
          color: #000000;
        }
        .item_time {
          font-size: 22px;
          font-family: SourceHanSansCN;
          font-weight: 400;
          color: #555;
          margin-top: 20px;
        }
        .item_dec {
          font-size: 26px;
          font-family: SourceHanSansCN;
          font-weight: 400;
          color: #1f1f1f;
          line-height: 48px;
          margin-top: 12px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
    }
  }
}
.pao2 {
  border-radius: 50%;
  background-image: -moz-linear-gradient(
    120deg,
    rgb(149, 219, 255) 0%,
    rgb(34, 107, 255) 81%
  );
  background-image: -webkit-linear-gradient(
    120deg,
    rgb(149, 219, 255) 0%,
    rgb(34, 107, 255) 81%
  );
  background-image: -ms-linear-gradient(
    120deg,
    rgb(149, 219, 255) 0%,
    rgb(34, 107, 255) 81%
  );
  background-image: linear-gradient(
    120deg,
    rgb(149, 219, 255) 0%,
    rgb(34, 107, 255) 81%
  );
  opacity: 0.7;
  left: -200px;
  top: 1003px;
  width: 303px;
  height: 303px;
}
.more_btn {
  width: 52px;
  height: 163px;
  border: 2px solid #7d7d7d;
  border-radius: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 20px;
  position: absolute;
  right: 0;
  cursor: pointer;
  transition: all 0.3s;

  span {
    font-size: 25px;
    color: rgb(125, 125, 125);
    word-wrap: break-word;
    display: inline-block;
    line-height: 22px;
    width: 82px;
    transform: rotate(90deg);
    margin-top: 35px;
    transition: all 0.3s;
  }
  i {
    width: 20px;
    height: 20px;
    background-color: #7d7d7dff;
    border-radius: 50%;
    margin-top: 30px;
    background-image: url('../assets/arrow5.png');
    background-size: 12px 12px;
    background-repeat: no-repeat;
    background-position: 1px center;
    transform: rotate(90deg);
    transition: all 0.3s;
  }
  &:hover {
    span {
      color: #48b8fb;
    }
    i {
      background-color: #48b8fb;
    }
    border: 1px solid #48b8fb;
  }
}
</style>